/* GPX-only stop gaps. No geocoding, navigation, rider location or persistence. */
(function(factory){if(typeof module==='object'&&module.exports)module.exports=factory();else window.Arvento360Legs=factory();})(function(){
'use strict';
// Search remains within200m. Official, verified store estimates may project
// beyond that corridor; near-equal local minima must agree within50m chainage.
const CORRIDOR_M=200,TIE_M=20,CHAINAGE_SPREAD_KM=.05,M_PER_DEG=111195.0802335329;
function project(route,stop,allowOffRoute){
 if(stop?.cp)return {status:'unknown',reason:'checkpoint',km:null};
 if(stop?.coordinateConflict)return {status:'unknown',reason:'conflict',km:null};
 const lat=stop?.lat,lon=stop?.lon;
 if((stop?.fromOSM!==true&&stop?.coordinateVerified!==true)||!Number.isFinite(lat)||Math.abs(lat)>90||!Number.isFinite(lon)||Math.abs(lon)>180)return {status:'unknown',reason:'coordinates',km:null};
 const x=M_PER_DEG*Math.cos(lat*Math.PI/180),y=M_PER_DEG,candidates=[];let best=Infinity,segment=0;
 for(let i=0;i<route.points.length-1;i++){
  const a=route.points[i],b=route.points[i+1],ax=(a[1]-lon)*x,ay=(a[0]-lat)*y,vx=(b[1]-a[1])*x,vy=(b[0]-a[0])*y,den=vx*vx+vy*vy;
  if(den<1e-12)continue;
  const index=segment++;
  const t=Math.max(0,Math.min(1,-(ax*vx+ay*vy)/den)),offset=Math.hypot(ax+vx*t,ay+vy*t);
  if(!allowOffRoute&&offset>CORRIDOR_M)continue;
  const km=route.cumulativeKm[i]+(route.cumulativeKm[i+1]-route.cumulativeKm[i])*t;
  candidates.push({offset,km,index});best=Math.min(best,offset);
 }
 if(!candidates.length)return {status:'unknown',reason:'off-route',km:null};
 // Neighboring clamped endpoints on a dense track are not separate visits.
 // Keep local distance minima before comparing distinct GPX chainages.
 const minima=candidates.filter((p,i)=>{
  const prev=candidates[i-1],next=candidates[i+1];
  return (!prev||prev.index!==p.index-1||p.offset<=prev.offset+1e-6)&&(!next||next.index!==p.index+1||p.offset<=next.offset+1e-6);
 });
 const plausible=minima.filter(p=>p.offset<=best+TIE_M),kms=plausible.map(p=>p.km);
 if(Math.max(...kms)-Math.min(...kms)>CHAINAGE_SPREAD_KM)return {status:'unknown',reason:'ambiguous',km:null};
 const closest=plausible.reduce((a,b)=>a.offset<=b.offset?a:b);
 return {status:'ok',reason:null,km:closest.km,offset:closest.offset};
}
function locate(route,stop){return project(route,stop,false);}
function offsetMeters(route,stop){
 const lat=stop?.lat,lon=stop?.lon;if(!Number.isFinite(lat)||Math.abs(lat)>90||!Number.isFinite(lon)||Math.abs(lon)>180||!Array.isArray(route?.points))return null;
 const x=M_PER_DEG*Math.cos(lat*Math.PI/180),y=M_PER_DEG;let best=Infinity;
 for(let i=0;i<route.points.length-1;i++){const a=route.points[i],b=route.points[i+1],ax=(a[1]-lon)*x,ay=(a[0]-lat)*y,vx=(b[1]-a[1])*x,vy=(b[0]-a[0])*y,den=vx*vx+vy*vy;if(den<1e-12)continue;const t=Math.max(0,Math.min(1,-(ax*vx+ay*vy)/den));best=Math.min(best,Math.hypot(ax+vx*t,ay+vy*t));}
 return Number.isFinite(best)?best:null;
}
function estimate(route,stop){
 if(stop?.cp===true){
  // Reference chainage from the active GPX profile, not a venue coordinate.
  // Never accept incoming/shared CP mileage as an authoritative anchor.
  const anchor=route?.checkpoints?.find(cp=>cp.id===stop.id),km=anchor?.km;
  if(anchor?.coordinateBasis==='landmark-reference'){
   const z=project(route,{...anchor,cp:false,coordinateVerified:true},true);
   return {...z,basis:'checkpoint-landmark'};
  }
  return Number.isFinite(km)&&km>=0&&km<=route.totalKm?{status:'ok',reason:null,km,basis:'checkpoint-reference'}:{status:'unknown',reason:'checkpoint',km:null};
 }
 return project(route,stop,stop?.coordinateVerified===true);
}
function legs(route,stops){
 const locations=stops.map(s=>estimate(route,s));
 return stops.slice(1).map((to,i)=>{
  const a=locations[i],b=locations[i+1],reasons=[...new Set([a,b].filter(p=>p.status!=='ok').map(p=>p.reason))];
  if(!reasons.length&&b.km<a.km-.001)reasons.push('order');
  if(!reasons.length&&Math.abs(b.km-a.km)<.001){
   const from=stops[i],x=M_PER_DEG*Math.cos(from.lat*Math.PI/180),separation=Math.hypot((to.lon-from.lon)*x,(to.lat-from.lat)*M_PER_DEG);
   if(separation>CORRIDOR_M)reasons.push('coincident');
  }
  return {fromId:stops[i].id,toId:to.id,status:reasons.length?'unknown':'ok',km:reasons.length?null:Math.max(0,b.km-a.km),reasons};
 });
}
return {locate,estimate,legs,offsetMeters};
});
